import React from 'react';
import { ToastContainer as LibToastContainer } from 'react-toastify';

interface IToastProps {
  limit?: number;
}

export const Toast = ({ limit = 1 }: IToastProps) => {
  return <LibToastContainer limit={limit} />;
};
